import './ccf-schedule-new-commitment-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfScheduleNewCommitmentIconProps extends SvgIconProps  {}
/**
 * component used to display schedule new commitment icon in call conference
 * @param props - CcfScheduleNewCommitmentIconProps
 * @example - <CcfScheduleNewCommitmentIcon />
 * @returns SVG of schedule new commitment icon in call conference
 */
export function CcfScheduleNewCommitmentIcon(
  props: CcfScheduleNewCommitmentIconProps
) {
  return (
    <SvgIcon width="16.915" height="19.484" viewBox="0 0 16.915 19.484" {...props} >
      <path 
        d="M-32.46-78.185a.924.924,0,0,0,.924-.924v-2.967A.924.924,0,0,0-32.46-83a.924.924,0,0,0-.924.924v2.967A.924.924,0,0,0-32.46-78.185Z" 
        transform="translate(44.595 83)"/>
        <path className="a" d="M-26.285-80.985H-27.5v1.259a2.315,2.315,0,0,1-2.312,2.312,2.315,2.315,0,0,1-2.312-2.312v-1.259H-35v1.259a2.315,2.315,0,0,1-2.312,2.312,2.315,2.315,0,0,1-2.312-2.312v-1.259H-40.8a1.2,1.2,0,0,0-1.2,1.2v14.464a1.2,1.2,0,0,0,1.2,1.2h14.516a1.2,1.2,0,0,0,1.2-1.2V-79.786A1.2,1.2,0,0,0-26.285-80.985Zm-.7,14.573a.4.4,0,0,1-.4.4H-39.715a.4.4,0,0,1-.4-.4v-7.519h13.131Z" 
        transform="translate(42 83.607)"/>
        <path className="a" 
        d="M-38.19-78.185a.924.924,0,0,0,.924-.924v-2.967A.924.924,0,0,0-38.19-83a.924.924,0,0,0-.924.924v2.967A.924.924,0,0,0-38.19-78.185Z" 
        transform="translate(42.869 83)"/>
    </SvgIcon>
  );
}

export default CcfScheduleNewCommitmentIcon;
